<template>
  <div class="mt-1">
    <h2> {{title}} </h2>
    <v-simple-table class="mt-2">
      <template v-slot:default>
        <thead class="strategio-bgtemplate-color">
          <tr>
            <th v-for="item in headers" :key="item.text" style="color: white;">{{ item.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.name"
          >
            <td v-for="head in headers" :key="head.text">{{ item[head.value] }}</td>
          </tr>
        </tbody>
        <tfoot class="strategio-bgtemplate-color">
          <tr v-for="item in footers" :key="item.text">
            <td v-for="head in headers" :key="head.text" style="color: white;">{{ item[head.value] }}</td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    footers: {
      type: Array,
      default: () => []
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/autoservicios/bonus/custom-bonus-table.vue